<template>
  <v-container fluid>

    <!-- Table search & filters -->
    <v-layout row wrap justify-space-between class="submissions-table-filters">
      <v-flex align-start xs4>
        <v-text-field
            solo-inverted
            flat
            label="Search"
            prepend-icon="search"
            v-model="search"
            clearable
          ></v-text-field>
      </v-flex>
      <v-flex align-end xs2>
        <v-select
                label="Status"
                :items="statuses"
                item-text="text"
                item-value="value"
                v-model="selectedStatus"
                prepend-icon="filter_list"
        ></v-select>
      </v-flex>
    </v-layout>
    <!-- /search & filters -->

    <!-- Submissions Table -->
    <v-data-table
      :headers="headers"
      :items="filteredItems"
      :rows-per-page-items="rowsPerPageItems"
      :pagination.sync="pagination"
      class="elevation-2 submissions-data-table"
      :search="search"
    >
   
      <template slot="items" slot-scope="props">
        <tr @click.stop="openSubmission(props.item.index)">
          <td class="text-xs-left" v-for="column in headers" v-bind:key="column.value">
            <v-avatar v-if="column.value=='user'" size="20" class="mr-1">
                <img :src="'https://randomuser.me/api/portraits/men/'+props.item.avatar+'.jpg'">
            </v-avatar>
            
            <v-icon v-if="column.value=='status' && props.item.status=='new'" small color="green">alarm_add</v-icon>
                
            {{ props.item[column.value] }}
              
          </td>  
        </tr>
      </template>
      

      <template slot="no-data">
        <v-alert :value="true" color="error" icon="warning">
          Sorry, nothing to display here :(
        </v-alert>
      </template>
      
    </v-data-table>
    <!-- /submissions table -->


    <!-- Single Submission View -->
    <v-dialog
          v-model="submissionDialog"
          fullscreen
          transition="slide-x-reverse-transition"
          scrollable
    >
   <div style="width:100%; height:100%;">
    <v-card class="dialogue-back">

            <!-- header toolbar -->
            <v-toolbar color="primary">
              <v-btn icon class="white--text" @click.native="submissionDialog = false">
                <v-icon>close</v-icon>
              </v-btn>
              <v-toolbar-title class="white--text">Vehicle Submission</v-toolbar-title>
              <!-- <v-subtitle>{{ currentSubmission.dateSubmitted }}</v-subtitle> -->
              <v-spacer></v-spacer>

                
              <v-menu 
              bottom
              origin="center center"
              transition="scale-transition"
              >
               <v-chip slot="activator" class="mr-2" color="white"> 
                <v-avatar size="32">
                  <v-progress-circular v-if="currentSubmission.status" size="24" :rotate="-90" :value="currentSubmission.progress" :color="currentSubmission.color"></v-progress-circular>
                </v-avatar>

                <strong>{{ currentSubmission.status }}</strong>
              
                <v-avatar class="ml-4" style="margin-right:-12px;" size="32">
                  <img v-if="currentSubmission.avatar" :src="'https://randomuser.me/api/portraits/men/'+currentSubmission.avatar+'.jpg'">
                </v-avatar>
              </v-chip>

             
              <v-list light>
                
                <v-list-tile
                v-for="(status, i) in statuses"
                :key="i"
                @click="updateSubmissionStatus(i)"
                v-if="status.value">
                  <v-list-tile-title>{{ status.text }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
              
              <v-toolbar-items>
                <v-btn dark flat @click.native="submissionDialog = false">Save</v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <!-- /header toolbar -->
      
            <!-- /dialog content -->
            <v-container grid-list-xl fluid>
              
              <v-layout row wrap>
                <v-flex xs12 sm4>
                  <!-- Vehicle Details -->
                  <v-card>
                    <v-img max-height="240" :src="img">
                          <v-layout
                            slot="placeholder"
                            fill-height
                            align-center
                            justify-center
                            ma-0
                          >
                            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                          </v-layout>
                    </v-img>  
                
                    <v-card-title primary-title>
                      <div>
                        <h3 class="headline mb-0"><strong>{{ currentSubmission.make }}</strong> {{ currentSubmission.model }}</h3>
                        <div class="grey--text pb-1">{{ currentSubmission.version }}</div>
                      </div>
                    </v-card-title>
                       
                    <v-divider></v-divider>

                    <v-subheader>Body</v-subheader>
                    <div class="pb-3 pl-2 pr-2">
                      <v-chip>
                        <v-avatar>
                          <v-icon class="ml-2">directions_car</v-icon>
                        </v-avatar>
                        {{ currentSubmission.bodyType }}
                      </v-chip>
                      <v-chip>
                        <v-avatar class="grey lighten-1"><strong>{{ currentSubmission.doors }}</strong></v-avatar>
                            Doors
                      </v-chip>
                      <v-chip>
                        <v-avatar :class="currentSubmission.colour"></v-avatar>
                          {{ currentSubmission.colour }}
                      </v-chip>
                    </div>

                    <v-divider></v-divider>
                          
                    <v-subheader>Engine</v-subheader>
                    <div class="pb-3 pl-2 pr-2">
                      <v-chip>
                        <strong>Size&nbsp;</strong>{{ currentSubmission.engineSize }}
                      </v-chip>

                      <v-chip>
                        <v-avatar>
                          <v-icon class="ml-2">local_gas_station</v-icon>
                        </v-avatar>
                        {{ currentSubmission.fuel }}
                      </v-chip>

                      <v-chip>
                        <v-avatar>
                          <v-icon class="ml-2">settings_applications</v-icon>
                        </v-avatar>
                        {{ currentSubmission.gearbox }}
                      </v-chip>
                    </div>
                            
                    <v-divider></v-divider>
                    
                    <v-subheader>Registration</v-subheader>
                    <div class="pb-3 pl-2 pr-2">
                      <v-chip color="yellow">
                        <!-- <v-avatar>
                          <v-icon>account_circle</v-icon>
                        </v-avatar> -->
                        <strong>{{ currentSubmission.reg }}</strong>
                      </v-chip>
                    </div>
                            
                  </v-card>
                  <!-- /Vehicle details -->

              </v-flex>

              <v-flex xs12 sm8>
                  
                    <div style="background:transparent;">
                <!-- TABS -->
               
                  <v-tabs
                    slot="extension"
                    v-model="tabs"
                    icons-and-text
                    color="transparent"
                    height="100"
                  >
                    <v-tabs-slider></v-tabs-slider>
                    
                    <v-tab href="#submission-tabs-1" class="primary--text">
                      Condition
                      <v-icon>directions_car</v-icon>
                    </v-tab>
            
                    <v-tab href="#submission-tabs-2" class="primary--text">
                      History
                      <v-icon>history</v-icon>
                    </v-tab>
            
                    <v-tab href="#submission-tabs-3" class="primary--text">
                      Customer
                      <v-icon>account_box</v-icon>
                    </v-tab>
                  </v-tabs>
                </div>
        
                <v-card>
                 <v-tabs-items v-model="tabs">

                  <!-- CONDITION TAB -->
                  <v-tab-item id="submission-tabs-1">
                    <v-container fluid>
                      <v-layout row wrap>
                        <v-flex sm12 md10 lg8>
                          
                          Rating
                          <v-tooltip bottom>
                          <v-rating 
                          class="hoverdesc"
                          v-model="currentSubmission.rating" 
                          length="10" 
                          size="30"
                          slot="activator"></v-rating>
                          <span>{{ ratingDescriptions[currentSubmission.rating] }}</span>
                          </v-tooltip>
                            
                            <v-textarea
                            name="vehicle-description"
                            label="Description"
                            class="mt-3"
                            rows="2"
                            auto-grow
                          
                            v-model="currentSubmission.description"></v-textarea>
                             
                            <v-layout row wrap>
                              <v-flex sm12 md6>
                                <v-text-field v-model="currentSubmission.mileage" prepend-icon="av_timer" label="Mileage"></v-text-field>
                              </v-flex>
                              <v-flex sm12 md6>
                                <v-text-field v-model="currentSubmission.owners" prepend-icon="people" label="Number of owners"></v-text-field>
                              </v-flex>
                            </v-layout>
                            
                            <v-layout row wrap>
                              <v-flex sm12 md6>
                                <v-text-field v-model="currentSubmission.taxExpiry" prepend-icon="calendar_today" label="Tax expiry"></v-text-field>
                              </v-flex>
                              <v-flex sm12 md6>
                                <v-text-field v-model="currentSubmission.nctExpiry" prepend-icon="calendar_today" label="NCT expiry"></v-text-field>
                              </v-flex>
                            </v-layout>
                        

                             
                        
                            <v-layout row wrap class="mb-3">
                              <v-flex xs12 sm6>
                                <v-checkbox
                                  v-model="currentSubmission.spareKey"
                                  label="Spare key"
                                  hide-details
                                ></v-checkbox>
                                <v-checkbox
                                  v-model="currentSubmission.spareTyre"
                                  label="Spare tyre"
                                  hide-details
                                ></v-checkbox>
                                <v-checkbox
                                  v-model="currentSubmission.tyresLegal"
                                  label="Tyres legal"
                                  hide-details
                                ></v-checkbox>
                              </v-flex>
                              <v-flex xs12 sm6>
                                <v-checkbox
                                  v-model="currentSubmission.windscreenDamage"
                                  label="Windscreen damage"
                                  hide-details
                                ></v-checkbox>
                                <v-checkbox
                                  v-model="currentSubmission.usedAsTaxi"
                                  label="Used as a taxi"
                                  hide-details
                                ></v-checkbox>
                                <v-checkbox
                                  v-model="currentSubmission.financeOutstanding"
                                  label="Finance outstanding"
                                  hide-details
                                ></v-checkbox>
                              </v-flex>
                            </v-layout>

                            <v-layout row wrap>
                              <v-flex sm12 md6>
                                <v-text-field v-model="currentSubmission.arrivalDate" prepend-icon="calendar_today" label="Arrival Date"></v-text-field>
                              </v-flex>
                              <v-flex sm12 md6>
                                <v-text-field v-model="currentSubmission.repairCost" prefix="£" label="Cost to repair"></v-text-field>
                              </v-flex>
                            </v-layout>

                        </v-flex>
                      </v-layout>

                     
                    </v-container>
                  </v-tab-item>
                  <!-- /CONDITION TAB -->

                  <!-- HISTORY TAB -->
                  <v-tab-item id="submission-tabs-2">
                    <v-container fluid>
                      <v-layout column>
                        <v-flex sm12 md10 lg8>
                          <v-layout justify-center align-center pt-3>
                            <v-icon size="100" color="grey lighten-2">
                              history
                            </v-icon>
                          </v-layout>
                          <v-layout justify-center align-center pb-3>
                            <h2 class="headline">Nothing to see here yet...</h2>
                          </v-layout>
                          <v-layout justify-center align-center pb-3>
                             <v-btn
                              :loading="loading3"
                              :disabled="loading3"
                              color="blue-grey"
                              class="white--text"
                              @click.native="loader = 'loading3'"
                              large
                            >
                              Download vehicle history
                              <v-icon right dark>cloud_download</v-icon>
                            </v-btn>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-tab-item>
                  <!-- HISTORY TAB -->
                  
                  <!-- CUSTOMER TAB -->
                  <v-tab-item id="submission-tabs-3">
                    <v-container fluid>
                      <v-layout row wrap>
                        <v-flex sm12 md10 lg8>
                            <v-layout row wrap>
                              <v-flex sm12 md6>
                                <v-text-field v-model="currentSubmission.firstName" prepend-icon="face" label="First Name"></v-text-field>
                              </v-flex>
                              <v-flex sm12 md6>
                                <v-text-field v-model="currentSubmission.surname" label="Surname"></v-text-field>
                              </v-flex>
                            </v-layout>
                            
                            <v-layout row wrap>
                              <v-flex sm12 md6>
                                <v-text-field v-model="currentSubmission.email" prepend-icon="email" label="Email"></v-text-field>
                              </v-flex>
                              <v-flex sm12 md6>
                                <v-text-field v-model="currentSubmission.tel" prepend-icon="phone" label="Phone"></v-text-field>
                              </v-flex>
                            </v-layout>

                            <v-layout row wrap>
                              <v-flex sm12 md6>
                                <v-text-field v-model="currentSubmission.county" prepend-icon="map" label="County"></v-text-field>
                              </v-flex>
                              <v-flex sm12 md6>
                                <v-text-field v-model="currentSubmission.postcode" prepend-icon="place" label="Post code"></v-text-field>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                    </v-container>
                  </v-tab-item>
                  <!-- /CUSTOMER TAB -->

                </v-tabs-items>
                
                <!-- /TABS -->
               
                </v-card>
              </v-flex>
            </v-layout>
            <div class="mt-3">
                <v-alert
                  :value="true"
                  outline
                  type="success"
                  color="grey"
                >
                  <strong>Submitted:</strong> {{ currentSubmission.dateSubmitted }}
                </v-alert>
              </div>
            </v-container>
            
       
    </v-card>
    </div>
    </v-dialog>
    <!-- / Single submission view -->


  </v-container>
</template>

<script>

import submissionsData from '../assets/submissions.json'

export default {
  name: 'submissionsList',
  data() {
    return {
      loader: null,
      loading3: false,
      carpic: 'https://loremflickr.com/320/240/car,vehicle,2018,',
      img: '',
      tabs: 1,
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      search: '',
      statuses: [
        { text: 'All', value: null, progress: null, icon: '',color: ''},
        { text: 'New', value: 'new', progress: null, icon: 'progress', progress: 25,color: 'amber'},
        { text: 'Abandoned', value: 'abandoned', icon: 'progress', progress: 10,color: 'amber'},
        { text: 'Incomplete', value: 'incomplete', icon: 'progress', progress: 15,color: 'amber'},
        { text: 'Offered', value: 'offered', icon: 'progress', progress: 50,color: 'green'},
        { text: 'Pending', value: 'pending', icon: 'progress', progress: 75,color: 'green'},
        { text: 'Won', value: 'won', icon: 'progress', progress: 100,color: 'green'},
        { text: 'Lost', value: 'lost', icon: 'cancel', progress: 100,color: 'red'},
        { text: 'Expired', value: 'expired', icon: 'cancel', progress: 100, color: 'red'}
      ],
      selectedStatus: null,
      currentSubmission: {},
      submissionDialog: false,
      rowsPerPageItems: [10, 25, 50],
      pagination: {
        rowsPerPage: 10
      },
      
      headers: [
        { text: 'Reg', value: 'reg' },
        { text: 'Make', value: 'make' },
        { text: 'Model', value: 'model' },
        { text: 'First name', value: 'firstName' },
        { text: 'Surname', value: 'surname' },
        { text: 'Tel', value: 'tel' },
        { text: 'Status', value: 'status' },
        { text: 'Last updated', value: 'lastUpdated' },
        { text: 'Staff member', value: 'user' },
        { text: 'submitted', value: 'dateSubmitted' }
      ],
      ratingDescriptions: [
        'desc 1',
        'desc2',
        'desc3',
        'desc4',
        'desc5',
        'desc6',
        'desc7',
        'desc8',
        'desc9',
        'desc10'
        
      ],
      submissions: submissionsData
    }
  },
  props: {
    
  },
  methods: {
    openSubmission: function(index){
      this.currentSubmission = this.submissions[index];
      var status = this.currentSubmission.status;
      for (var i=0; i<this.statuses.length; i++){
        if(this.statuses[i].value==status){
          this.currentSubmission.progress = this.statuses[i].progress;
          this.currentSubmission.color = this.statuses[i].color;
        }
      }
      this.getCarImage(this.currentSubmission.make);
      this.submissionDialog = true;
    },
    updateSubmissionStatus: function(index){
      this.currentSubmission.status = this.statuses[index].value;
      this.currentSubmission.progress = this.statuses[index].progress;
      this.currentSubmission.color = this.statuses[index].color;
    },
    getCarImage: function(make){
      var apiKey = 'AIzaSyDzvYjtT7MKS8z59-4ZgSx59YrEnJIsdwQ';
      var cx = '000802721154775260942:hpzttaoa3eu'; 
      var fType = 'png%2C+gif%2C+jpg';
      var imageSize = 'small';
      //var imgDominantColor = 'black';
      var endpointURL = 'https://www.googleapis.com/customsearch/v1?';
      var q = make+' vehicle car 2018';
      var num = 1;
      var requestURL = endpointURL + 'q=' + q + '&fileType=' + fType + '&imgSize=' + imageSize + '&cx=' + cx + '&key=' + apiKey + '&num=' + num;
      var that = this;
      fetch(requestURL, {
        method: 'get'
      })
      .then(
        function(response) {
          if (response.status !== 200) {
            console.log('Looks like there was a problem. Status Code: ' +
              response.status);
            return;
          }

          //console.log(response)
          // Examine the text in the response
          response.json().then(function(data) {
            //console.log(JSON.stringify(data));
             var items = data.items;
             var imageURL = '';
            items.forEach( function(item){
              imageURL = item.pagemap.cse_image[0].src;
            });
            that.img = imageURL;
          });
        }
      ) 
      .catch(function(err) {
        console.log('Fetch Error :-S', err);
      });



    }
  },
  watch: {
    loader () {
      const l = this.loader
      this[l] = !this[l]

      setTimeout(() => (this[l] = false), 3000)

      this.loader = null
    }
  },
  computed: {
    filteredItems() {
      return this.submissions.filter((i) => {
        return !this.selectedStatus || (i.status === this.selectedStatus);
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.submissions-data-table td{
  cursor: pointer;
}

.dialogue-back{
  background-color: #F2F2F2;
}

.theme--dark.dialogue-back{
  background-color: #333;
}

.v-content__wrap{
  background-color: #F2F2F2;
}

.theme--dark.v-content__wrap{
  background-color: #333;
}

/* experiment */
.hoverdesc > .v-icon:nth-child(1):hover:after{
  position: absolute;
  content: "Hi Im the description...";
  top: 30px;
  background: yellow;
  color: black;
  padding: 10px;

}
</style>
